/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_File_Tree_Toast_Success_OkInputs */

const es_components_file_tree_toast_success_ok = /** @type {(inputs: Components_File_Tree_Toast_Success_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivos ingeridos`)
};

const en_components_file_tree_toast_success_ok = /** @type {(inputs: Components_File_Tree_Toast_Success_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files ingested`)
};

/**
* | output |
* | --- |
* | "{count} files ingested" |
*
* @param {Components_File_Tree_Toast_Success_OkInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_success_ok = /** @type {((inputs: Components_File_Tree_Toast_Success_OkInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Success_OkInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_success_ok(inputs)
	return en_components_file_tree_toast_success_ok(inputs)
});
export { components_file_tree_toast_success_ok as "components.file_tree.toast_success_ok" }